import { render, staticRenderFns } from "./SettingGroups.vue?vue&type=template&id=4cd88c47&"
import script from "./SettingGroups.vue?vue&type=script&lang=js&"
export * from "./SettingGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports